<template>
    <!--COMMIT DIALOG-->
    <div>
        <v-dialog v-model="commitdialog" max-width="300px" scrollable>
            <v-card>
                <v-card-title class="subtitle-2">Set Commit</v-card-title>
                <v-card-text>
                    <v-text-field
                            v-if="!activeschool"
                            label="College Name"
                            v-model="search"
                            :value="search==false?'':search"
                            outlined
                            @keyup="searchcommit()"
                    ></v-text-field>

                    <!--  display selection-->
                    <v-list v-if="activeschool">
                        <v-list-item
                                :key="activeschool.id"
                        >
                            <v-list-item-avatar>
                                <img :src="activeschool.img">
                            </v-list-item-avatar>
                            <v-list-item-content>
                                <v-list-item-title v-text="activeschool.name"></v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-action>
                                <v-btn icon @click="activeschool=undefined">
                                    <v-icon>
                                        {{icons.close}}
                                    </v-icon>
                                </v-btn>
                            </v-list-item-action>
                        </v-list-item>
                    </v-list>


                    <v-list v-if="!activeschool">
                        <v-list-item
                                v-for="(s,i) in searchresults"
                                :key="i.id"
                                @click="activeschool=s,search='',searchresults=[]"
                        >

                            <v-list-item-content>
                                <v-list-item-title v-text="s.name"></v-list-item-title>
                            </v-list-item-content>

                            <v-list-item-avatar>
                                <img :src="s.img">
                            </v-list-item-avatar>

                        </v-list-item>
                    </v-list>

                    <v-select
                            label="Sport"
                            :items="items"
                            item-text="name"
                            item-value="code"
                            :v-model="sport"
                            @change="setE($event)"
                    ></v-select>

                </v-card-text>
                <v-card-actions>
                    <v-btn text @click="Close()">Close</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn text @click="setcommit(activeschool.partkey)" :disabled="!activeschool || !sport" :loading="loading">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="decommitdialog" max-width="500px">
            <v-card>
                <v-card-title>De-Commit</v-card-title>
                <v-card-text>
                    This will remove<br/>
                    <img :src="displaycommit.img" height="50"/>
                    <span class="title font-weight-thin">{{displaycommit.name}}</span><br/><br/>
                    from your active profile
                </v-card-text>
                <v-card-actions>
                    <v-btn text color="red darken-4" @click="decommit()" :loading="loading">Continue</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn text color="info" @click="Close()">Cancel</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>

</template>

<script>
  import {
    mapState,
    mapActions
  } from 'vuex'

  export default {
    name: "SetCommit",
    components: {},
    props: ['commitdialog', 'decommitdialog', 'displaycommit'],
    data() {
      return {
        sport:undefined,
        activeschool: undefined,
        search:'',
        searchresults: [],
        loading:false,
        items:[
          {
            name: 'Beach Volleyball',
            code:'beach'
          },
          {
            name: 'Indoor Volleyball',
            code:'volleyball'
          }
        ]
      }
    },
    mounted(){
      this.sport = this.items.filter(f=>{return f.code===this.sportcode})[0]
    },
    computed: {
      ...mapState(['activeplayer', 'sportcode','icons'])
    },
    methods: {
      ...mapActions(['get', 'post']),
      async searchcommit() {
        if(!this.search.trim())return
        let s = await this.get({path: 'api/playerv2/searchcollege/' + this.search.trim()})
        console.log('S',s)
        this.searchresults = s
      },
      async setcommit(partkey) {
        console.log(this.sport)
        let data = {
          sport: this.sport.code,
          playerpartkey: this.activeplayer.partkey,
          collegepartkey: partkey,
          committed: 1
        }
        this.loading=true
        await this.post({path: 'api/playerv2/setcommit/', body:data})
        this.loading=false
        this.searchresults=undefined
        this.$emit('success',true)
        this.Close()
      },
      async decommit() {
        let data={
          sport: this.sportcode,
          playerpartkey: this.activeplayer.partkey,
          committed: 0
        }
        this.loading=true
        await this.post({path:'api/playerv2/decommit/',body:data})
        this.loading=false
        this.$emit('success',true)
        this.Close()
      },
      Close(){
        this.search=''
        this.searchresults=[]
        this.activeschool=undefined
        this.$emit('close',true)
      },
      setE(e){
        console.log(e)
      }
    }
  }

</script>

<style scoped>

</style>